import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useMatch } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import FormInput from '../../components/FormInput';
import FormLabel from '../../components/FormLabel';
import SimpleButton from '../../components/SimpleButton';
import Spacer from '../../components/Spacer';
import { IApplicationState } from '../../store';
import { sweepMemberDraftUpdate, sweepsSaveGuestRequest } from '../../store/sweeps/slice';
import { ISweepMember, } from '../../store/sweeps/types';
import { Container } from './styles';

const GuestForm: React.FC = (props) => {
    const route = useMatch('/guest-member/:idSweep/:idMember/form');

    const routeRegister = useMatch('/guest-member/:idSweep/form');

    const { t } = useTranslation();

    const idSweep = route?.params.idSweep || routeRegister?.params.idSweep;

    const idMember = route?.params.idMember;

    const sweep = useSelector((state: IApplicationState) => state.sweeps.data.find(sweep => sweep.id === idSweep))

    const member = sweep?.members.find(member => member.id === idMember);

    const sweeps = useSelector((state: IApplicationState) => state.sweeps);

    const dispatch = useDispatch();

    const [isLoaded, setIsLoaded] = useState(false);

    const editingGuest = sweeps.draftMember;

    const setEditingGuest = useCallback((guest: ISweepMember) => {
        dispatch(sweepMemberDraftUpdate(guest))
    }, [dispatch])

    useEffect(() => {
        if (member && !isLoaded) {
            setEditingGuest({
                ...member,
                error: undefined
            });
            setIsLoaded(true)
        }
    }, [member, isLoaded, setEditingGuest]);

    if (!editingGuest) {
        return (
            <Container>
                <h1>{t("pages.sweeps.guest_not_found_form")}</h1>
            </Container>
        );
    }

    return (
        <Container>
            <h1>{!member ? t("pages.sweeps.create_guest") : t("pages.sweeps.edit_guest")}</h1>

            <FormLabel>{t("pages.sweeps.guest_name")}</FormLabel>
            <FormInput
                value={editingGuest?.name || ""}
                onChangeText={(text) => {
                    setEditingGuest({
                        ...editingGuest,
                        name: text
                    })
                }}
            />

            <FormLabel>{t("pages.sweeps.guest_role")}</FormLabel>
            <FormInput
                value={editingGuest?.role || ""}
                onChangeText={(text) => {
                    setEditingGuest({
                        ...editingGuest,
                        role: text
                    })
                }}
            />

            <Spacer size={20} />

            <SimpleButton
                prependIcon='save'
                color='primary'
                disabled={editingGuest.isSaving}
                onClick={() => {
                    dispatch(sweepsSaveGuestRequest(editingGuest))
                }}>
                {editingGuest.isSaving ? `${t("common.buttons.saving")}...` : t("common.buttons.save")}
            </SimpleButton>

            <Spacer size={20} />

            {editingGuest.error && <ErrorMessage>{editingGuest.error || t("common.unexpected")}</ErrorMessage>}
        </Container>
    );
}

export default GuestForm;